var _path, _path2, _path3, _path4, _path5;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCategoryBookings(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.0001 24.7256C8.06916 24.7256 6.17227 25.2339 4.50006 26.1994L3.63403 26.6994L2.63403 24.9673L3.50006 24.4673C5.47631 23.3263 7.71808 22.7256 10.0001 22.7256C12.0917 22.7256 14.1495 23.2303 16.0001 24.1931C17.8506 23.2303 19.9084 22.7256 22.0001 22.7256C24.282 22.7256 26.5238 23.3263 28.5001 24.4673L29.3661 24.9673L28.3661 26.6994L27.5001 26.1994C25.8278 25.2339 23.931 24.7256 22.0001 24.7256C20.0692 24.7256 18.1723 25.2339 16.5001 26.1994L16.0001 26.488L15.5001 26.1994C13.8278 25.2339 11.931 24.7256 10.0001 24.7256Z",
    fill: "#212121"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.0001 7.39233C8.06916 7.39233 6.17227 7.9006 4.50006 8.86605L3.63403 9.36605L2.63403 7.634L3.50006 7.134C5.47631 5.99302 7.71808 5.39233 10.0001 5.39233C12.0917 5.39233 14.1495 5.89698 16.0001 6.85977C17.8506 5.89698 19.9084 5.39233 22.0001 5.39233C24.282 5.39233 26.5238 5.99302 28.5001 7.134L29.3661 7.634L28.3661 9.36605L27.5001 8.86605C25.8278 7.9006 23.931 7.39233 22.0001 7.39233C20.0692 7.39233 18.1723 7.9006 16.5001 8.86605L16.0001 9.15473L15.5001 8.86605C13.8278 7.9006 11.931 7.39233 10.0001 7.39233Z",
    fill: "#212121"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5 8V25.3333H3V8H5Z",
    fill: "#212121"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17 7V25.3333H15V7H17Z",
    fill: "#212121"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M29 8V25.3333H27V8H29Z",
    fill: "#212121"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCategoryBookings);
export default __webpack_public_path__ + "static/media/category-bookings.287a3e30ade2bafaaeaf21c6d8eb5d2f.svg";
export { ForwardRef as ReactComponent };